import { Controller } from "stimulus";

export default class ReadTrackingController extends Controller {
  static values = { postId: Number };

  connect() {
    this.maxBucket = -1;
    this.sent = false;

    this._onScroll = () => this.trackScroll();
    this._onVisibility = () => { if (document.visibilityState === "hidden") this.send(); };
    this._onPageHide = () => this.send();

    window.addEventListener("scroll", this._onScroll, { passive: true });
    document.addEventListener("visibilitychange", this._onVisibility);
    window.addEventListener("pagehide", this._onPageHide);

    this.trackScroll();
  }

  disconnect() {
    window.removeEventListener("scroll", this._onScroll);
    document.removeEventListener("visibilitychange", this._onVisibility);
    window.removeEventListener("pagehide", this._onPageHide);
    this.send();
  }

  trackScroll() {
    const contentTop = this.element.getBoundingClientRect().top + window.scrollY;
    const contentHeight = this.element.offsetHeight;
    if (contentHeight <= 0) return;

    const scrolledIntoContent = window.scrollY + window.innerHeight - contentTop;
    const bucket = Math.min(Math.floor((scrolledIntoContent / contentHeight) * 10), 9);

    if (bucket > this.maxBucket) {
      this.maxBucket = bucket;
    }
  }

  send() {
    if (this.sent || this.maxBucket < 0) return;
    this.sent = true;

    const body = JSON.stringify({
      post_id: this.postIdValue,
      max_depth: this.maxBucket,
    });

    if (navigator.sendBeacon) {
      navigator.sendBeacon(
        "/subscriber_v2/posts/read_tracking",
        new Blob([body], { type: "application/json" })
      );
    } else {
      fetch("/subscriber_v2/posts/read_tracking", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      });
    }
  }
}
